import { render, staticRenderFns } from "./editTagTem.vue?vue&type=template&id=8b08c0f8&"
import script from "./editTagTem.vue?vue&type=script&lang=js&"
export * from "./editTagTem.vue?vue&type=script&lang=js&"
import style0 from "./editTagTem.vue?vue&type=style&index=0&id=8b08c0f8&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports